'use client';

import { getDefaultConfig, RainbowKitProvider, midnightTheme } from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { arbitrumSepolia, arbitrum } from 'wagmi/chains';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ModalProvider } from '@/providers/ModalProvider';
import { Toaster } from '@/components/ui/sonner';

export const defaultChain = process.env.NEXT_PUBLIC_NETWORK === 'MAINNET' ? arbitrum : arbitrumSepolia;

const config = getDefaultConfig({
  appName: 'HPPC Interface',
  projectId: 'YOUR_PROJECT_ID',
  chains: [defaultChain],
  ssr: true, // If your dApp uses server side rendering (SSR)
});

const queryClient = new QueryClient();

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={midnightTheme()}>
          <ModalProvider>
            {children}
            <Toaster />
          </ModalProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
